import { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import api from "../services/api";
import { useToast } from '../context/ToastContext';
import { ALERTAS, LEGENDA_BOLETIM } from '../utilities/constantes';
import ICartao from '../interfaces/ICartao';
import util from '../utilities/util';
import { Divider } from 'primereact/divider';
import { useForm } from 'react-hook-form';
import { SCDropdown, SCDialog, SCFieldset, SCInputText, SCInputNumber, SCButton } from '../components';
import { SlideMenu } from 'primereact/slidemenu';
import CartaoForm from './CartaoForm';
import AjudaFormTela from './AjudaFormTela';
import IFormaPagamento from '../interfaces/IFormaPagamento';
import Loading from '../components/Loading';
import { PickList } from 'primereact/picklist';
import { ReactSortable } from 'react-sortablejs';

const ConfiguracoesBoletim = () => {
    const toast = useToast();
    const tarefa = 'ConfiguracoesBoletim';

    const [loading, setLoading] = useState<boolean>(false);
    const [quantidadeSelecionada, setQuantidadeSelecionada] = useState<number | null>(null);
    const [inputNumero, setInputNumero] = useState<number | null>(null);
    const dt = useRef<any>(null);
    const menu = useRef<any>(null);

    const methods = useForm({});
    const { handleSubmit, control, formState: { errors }, watch, setValue, getValues } = methods;

    const load = async () => {

    }


    useEffect(() => {
        load();
    }, []);

    const openNew = () => {

    };

    const hideDialog = () => {

    };
    const editar = (item: any) => {

    };

    const confirmDelete = (item: any) => {

    };

    const deletar = async () => {

    };

    const onSubmit = async (data: any) => {
        load();
    }

    const opcoes = [
        {
            label: 'Imprimir',
            icon: 'pi pi-print',
            command: () => {
                dt.current.exportCSV();
            }
        },
        {
            label: 'Exp. para Excel',
            icon: 'pi pi-file-excel',
            command: () => {
                dt.current.exportCSV();
            }
        },
        {
            label: 'Ajuda',
            icon: 'pi pi-question-circle',
            command: () => {
                dt.current.exportCSV();
            }
        },
    ];

    const clearState = () => {
        dt?.current?.reset();
    }

    const openMenu = (event: any) => {
        menu?.current?.toggle(event)
    };

    const [state, setState] = useState(
        LEGENDA_BOLETIM.map((item: any, index: any) => ({
            id: String(index + 1),
            value: "",
            fixedText: item.descricao
        }))
    );

    const handleInputChange = (id: number | string, newValue: any) => {
        setState(prev =>
            prev.map(item => (item.id === id ? { ...item, value: newValue } : item))
        );
    };

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <div className='flex justify-content-center align-items-center p-2 border-round-top-md text-white' style={{ backgroundColor: '#0772B3' }}>
                        <h5 className="m-0 flex flex-1 align-items-center justify-content-center">Configurações de Boletim</h5>
                    </div>

                    <SCFieldset legend='Identificação das Colunas do Boletim' className='mt-2'>
                        <div className='grid'>
                            <div className="col-12 md:col-2">
                                <SCInputNumber
                                    label='Número de Colunas'
                                    value={inputNumero}
                                    onValueChange={(e) => setInputNumero(e.value)}
                                />
                            </div>
                            <div className='col-12 md:col-2 flex align-items-end justify-content-around'>
                                <SCButton label='Gerar Colunas' className="p-button-success pl-1 w-100" type='button' onClick={() => setQuantidadeSelecionada(inputNumero)} />
                            </div>
                        </div>
                        <div className='grid mt-3'>
                            <ReactSortable list={state} setList={setState} className="grid">
                                {state.map((item, index) => {
                                    const selecionado = quantidadeSelecionada != null && index < quantidadeSelecionada;
                                    return (
                                        <div
                                            key={item.id}
                                            className="card"
                                            style={{
                                                width: "110px",
                                                height: "100px",
                                                // border: `2px solid ${quantidadeSelecionada == null ? "#ccc" : selecionado ? "green" : "red"}`,
                                                backgroundColor: quantidadeSelecionada == null ? "#fff" : selecionado ? "#87ad91" : "#f8d7da",
                                                margin: "10px",
                                                padding: "10px",
                                                borderRadius: "8px",
                                                display: "flex",
                                                flexDirection: "column",
                                                // justifyContent: "space-between"
                                                justifyContent: "center",
                                                alignItems: "center",
                                                textAlign: "center",
                                                gap: "8px"
                                            }}
                                        >
                                            <div>Coluna {index + 1}</div>
                                            <div style={{ fontWeight: "bold" }} className=''>{item.fixedText}</div>
                                            <SCInputText
                                                style={{ width: "100%", boxSizing: "border-box", textAlign: "center" }}
                                                value={item.value}
                                                disabled={quantidadeSelecionada == null ? true : selecionado ? false : true}
                                                onChange={(e) =>
                                                    setState((prev) =>
                                                        prev.map((el) =>
                                                            el.id === item.id ? { ...el, value: e.target.value } : el
                                                        )
                                                    )
                                                }
                                            />
                                        </div>
                                    )
                                })}
                            </ReactSortable>
                        </div>
                    </SCFieldset>

                    <SCFieldset legend='Legendas' className='mt-2'>
                        <div className='grid'>
                            <div className='col-6'>
                                <span style={{ fontWeight: "bold" }}>NotaB1</span>  = Nota da 1ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>NotaB2</span>  = Nota da 2ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>NotaRI</span>  = Nota da Recuperação Intermediária <br />
                                <span style={{ fontWeight: "bold" }}>NotaB3</span>  = Nota da 3ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>NotaB4</span>  = Nota da 4ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>NotaB5</span>  = Nota da 5ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>NotaB6</span>  = Nota da 6ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>RecupB1</span> = Nota da Recuperação da 1ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>RecupB2</span> = Nota da Recuperação da 2ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>RecupB3</span> = Nota da Recuperação da 3ª Bimestral <br />
                            </div>
                            <div className='col-6'>
                                <span style={{ fontWeight: "bold" }}>RecupB4</span> = Nota da Recuperação da 4ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>RecupB5</span> = Nota da Recuperação da 5ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>RecupB6</span> = Nota da Recuperação da 6ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>TotFal</span>  = Total de Faltas <br />
                                <span style={{ fontWeight: "bold" }}>PerFal</span>  = Percental do Total de Faltas <br />
                                <span style={{ fontWeight: "bold" }}>Total</span>   = Total das notas <br />
                                <span style={{ fontWeight: "bold" }}>Média</span>   = Média das notas <br />
                                <span style={{ fontWeight: "bold" }}>MedBim1</span> = Média das notas da 1ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>MedBim2</span> = Média das notas da 2ª Bimestral <br />
                                <span style={{ fontWeight: "bold" }}>Precisa</span> = Nota que o aluno precisa para ser aprovado <br />
                            </div>
                        </div>
                    </SCFieldset>
                </div>
            </div>
        </div>
    );
};

export default ConfiguracoesBoletim;
